import  {createContext, useContext} from "react";

const rememberContext = createContext();

export function useRemember() {
    return useContext(rememberContext);
}

function provideRemember(){
    const map = {};

    const setValue = (key, val)=>{
        map[key] = val;
    }

    const getValue = (key, defaultValue)=>{
        if(map[key] === undefined)
            return defaultValue;
        return map[key]
    }

    return {setValue, getValue };
}

export default function ProvideRemember({ children }) {
    const remember = provideRemember();

    return (
        <rememberContext.Provider value={remember}>
            {children}
        </rememberContext.Provider>
    );
}
